import {styled} from '@epic-ui/epic/src/styled-components';

export const InterviewIframe = styled.iframe`
    border: 0;
    width: 100%;
    min-height: 800px;
`;

InterviewIframe.displayName = 'InterviewIframe';
